import React, {Component} from "react";
import StrapDisplay from "./StrapDisplay";

const curl ="https://bwapi.onrender.com/categories";

class Strap extends Component{

    constructor(){
        super()
        this.state={
            category:''
        }
        
    }

    render(){
        return(
            <div className="d-flex justify-content-center w-100 bg-dark dark">        
                    
                       <StrapDisplay categoriesData={this.state.category}/>
                    
            </div>  
        
        )
    }
    


    // api call
    componentDidMount() {
        fetch(curl,{method:'GET'})
        .then((res)=> res.json())
        .then((data)=>{
            this.setState({category:data})
        })
    }

}

export default Strap;